import { useAuth } from '../lib/auth';

export default function Login() {
  const { signIn } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F3F1] text-gray-900 px-4">
      <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-lg space-y-6 text-center">
        <h1 className="text-3xl font-bold">SnapGrad</h1>
        <div className="space-y-2">
          <h2 className="text-2xl font-semibold">Sign in</h2>
          <p className="text-gray-600">Use Google to continue.</p>
        </div>
        
        <button
          onClick={() => signIn('Google')}
          className="w-full bg-[#F36F21] text-white font-semibold py-3 rounded-lg hover:bg-[#d85f1c] transition duration-200"
        >
          Continue with Google
        </button>
        
        <div className="pt-4 border-t border-gray-200">
          <p className="text-sm text-gray-600">
            Don't have an account? Contact support to sign up.
          </p>
        </div>
      </div>
    </div>
  );
}